import { useDispatch } from 'react-redux';
import tokenService from '../services/token';
import { clearInfoUser } from '../store/slices/infoUserSlice';
import { clearPermission } from '../store/slices/permissionSlice';
import { clearMenu } from '../store/slices/menuSlice';
import { clearUnitByUserPermission } from '../store/slices/UnitByUserPermission';
import { clearGroupCustumer } from '../store/slices/groupCustumerSlice';

const useResetData = () => {
  const dispatch = useDispatch();

  const resetLoginOut = () => {
    tokenService.removeToken()
    dispatch(clearInfoUser())
    dispatch(clearMenu())
    dispatch(clearPermission())
    dispatch(clearUnitByUserPermission())
    dispatch(clearGroupCustumer())
  };

  const resetLoginExpired = () => {
    tokenService.removeToken()
    dispatch(clearInfoUser())
    dispatch(clearPermission())
    dispatch(clearMenu())
    dispatch(clearUnitByUserPermission())
    dispatch(clearGroupCustumer())
  };
  const resetAllData = () => {
    tokenService.removeToken()
    dispatch(clearInfoUser())
    dispatch(clearPermission())
    dispatch(clearMenu())
    dispatch(clearUnitByUserPermission())
    dispatch(clearGroupCustumer())
  };

  return {
    resetLoginOut,
    resetLoginExpired,
    resetAllData
  };
};

export default useResetData;
